module.exports = __webpack_public_path__ + "static/sheng-e69e530ca0b2464c5006853417ba3435.png";